import { StandardShelfCalculator } from './../Standard';
import { IStand } from "./Model/IStand";
import { SurfaceTypesEnum } from '../Standard/Enum/SurfaceTypesEnum'
import { ISelect } from '../Standard/Model/ISelect';

export class SalgoCsavarmentesShelfCalculator extends StandardShelfCalculator {
  // Állványok
  private stands: IStand[] = [];

  constructor(props) {
    super(props);

    this.type = "salgo-csavarmentes";
    this.name = "Salgó csavarmentes polcrendszer tervező";
    this.previewImage = "/images/content/preview/salgo-csavarmentes.jpg";

    this.surfaces = [SurfaceTypesEnum.Horganyzott];
    this.shelfsNumber = [4, 5, 6, 7];
    this.fieldsNumber = [1, 2, 3, 4];

    this.stands = [
      { height: 3000, depth: 800, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 13860}] },
      { height: 3000, depth: 700, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 13175}] },
      { height: 3000, depth: 600, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 12471}] },
      { height: 3000, depth: 500, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 11824}] },
      { height: 3000, depth: 400, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 11428}] },
      { height: 3000, depth: 320, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 11055}] },
      { height: 3000, depth: 250, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 10937}] },
      { height: 2500, depth: 800, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 11138}] },
      { height: 2500, depth: 700, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 10650}] },
      { height: 2500, depth: 600, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 10078}] },
      { height: 2500, depth: 500, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 9568}] },
      { height: 2500, depth: 400, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 9254}] },
      { height: 2500, depth: 320, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 8980}] },
      { height: 2500, depth: 250, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 9171}] },
      { height: 2000, depth: 800, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 9047}] },
      { height: 2000, depth: 700, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 8631}] },
      { height: 2000, depth: 600, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 8170}] },
      { height: 2000, depth: 500, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 7753}] },
      { height: 2000, depth: 400, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 7497}] },
      { height: 2000, depth: 320, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 7267}] },
      { height: 2000, depth: 250, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 7395}] },
      // { height: 1600, depth: 320, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 5571}] },
    ];

    this.shelfs = [
      { width: 1800, depth: 800, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 14694}] },
      { width: 1800, depth: 700, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 13158}] },
      { width: 1800, depth: 600, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 12090}] },
      { width: 1800, depth: 500, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 10464}] },
      { width: 1800, depth: 400, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 9504}] },
      { width: 1800, depth: 320, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 8810}] },
      { width: 1800, depth: 250, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 8198}] },
      { width: 1500, depth: 800, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 9785}] },
      { width: 1500, depth: 700, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 8551}] },
      { width: 1500, depth: 600, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 7655}] },
      { width: 1500, depth: 500, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 6291}] },
      { width: 1500, depth: 400, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 5486}] },
      { width: 1500, depth: 320, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 4901}] },
      { width: 1500, depth: 250, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 4388}] },
      { width: 1200, depth: 800, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 7824}] },
      { width: 1200, depth: 700, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 6894}] },
      { width: 1200, depth: 600, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 6170}] },
      { width: 1200, depth: 500, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 5068}] },
      { width: 1200, depth: 400, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 4414}] },
      { width: 1200, depth: 320, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 3941}] },
      { width: 1200, depth: 250, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 3528}] },
      { width: 900, depth: 800, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 5851}] },
      { width: 900, depth: 700, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 5083}] },
      { width: 900, depth: 600, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 4548}] },
      { width: 900, depth: 500, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 3736}] },
      { width: 900, depth: 400, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 3256}] },
      { width: 900, depth: 320, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 2908}] },
      { width: 900, depth: 250, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 2603}] },
      { width: 600, depth: 800, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 3951}] },
      { width: 600, depth: 700, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 3487}] },
      { width: 600, depth: 600, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 3126}] },
      { width: 600, depth: 500, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 2574}] },
      { width: 600, depth: 400, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 2247}] },
      { width: 600, depth: 320, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 2011}] },
      { width: 600, depth: 250, price: [{ surface: SurfaceTypesEnum.Horganyzott, price: 1804}] },
    ];

    this.multiplier = 1.0;

    this.init();

    let heights: number[] = [];
    for (let i = 0; i < this.stands.length; i++) {
      heights.push(this.stands[i].height);
    }
    this.setHeights(heights);
  }

  calculatePrice() {
    this.logger.log("calculatePrice SalgoCsavarmentesShelfCalculator");

    let system = this.getSystem();
    this.logger.log(system);

    let systemPrice = 0;
    let standsNumber = system.fieldsNumber + 1;
    this.logger.log("Állványok száma:", standsNumber);

    let standPrice = this.stands
      .find(currenct => currenct.depth === system.depth && currenct.height === system.height)?.price
      .find(current => current.surface === system.surface)?.price ?? 0;

    this.logger.log("Állvány ára:", standPrice);
    systemPrice += standsNumber * standPrice;

    for (let i = 0; i < system.fieldsNumber; i++) {
      let shelfValue = this.shelfs
        .find(current => current.depth === system.depth && current.width === system.shelfsWidth[i])!.price
        .find(current => current.surface === system.surface)!.price;

      this.logger.log("#" + (i + 1) + " Polc ára:", shelfValue);

      systemPrice += shelfValue * system.shelfsNumber;
    }

    systemPrice *= this.multiplier;

    this.logger.log("Rendszer ára:", systemPrice);

    this.setState({
      netPrice: systemPrice,
      grossPrice: systemPrice * 1.27
    })
  }

  checkShelfsDepth(current: ISelect) {
    const system = this.getSystem();
    const currentDepth = current.value;

    let standPrice = this.stands
      .find(current => current.depth === currentDepth && current.height === system.height)?.price
      .find(current => current.surface === system.surface)?.price ?? 0;

    return standPrice ? true : false;
  }
}

export default SalgoCsavarmentesShelfCalculator;